'use strict';
angular.module('resourceCenterMaterialModule').controller('picSearchCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$timeout',
    'options',
    'modalDialog',
    'mrApiService',
    'trsspliceString',
    'mediaTagApiService',
    function (
        $scope,
        $q,
        $modalInstance,
        $timeout,
        options,
        modalDialog,
        mrApiService,
        trsspliceString,
        mediaTagApiService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.windowTitle = '选择图片';
            $scope.page = {
                ITEMCOUNT: 0,
                CURRPAGE: 1,
                PAGESIZE: 8,
                PAGECOUNT: 1,
            };
            // 主控制器status状态
            $scope.basicalStatus = {
                copyCurrPage: 1,
                commonParams:{
                    mainResourceType: '0',
                },
                searchParams: {
                    customStartTime: '',
                    customEndTime: '',
                },
                allowPicSearch: false,
            };
            $scope.tagsData = {
                tags: [], // 选中的标签列表
                tagsList: [], // 搜索出的标签列表
                searchTags: '', // 标签搜索关键字
                selectedTag: {}, // 选中标签对象
            };
            $scope.items = [];
            $scope.selectedArray = [];
            $scope.status = {
                iframeHeight: '225',
                iframeWidth: '400',
            };
            $scope.isShowPicSearchResult = false; // 是否显示识图结果数量
            $scope.searchByPicParams = {
                file: '',
                mrType: '',
                labelIds: '',
                pageNum: 1,
                pageSize: 8,
                customEndTime: '',
                customStartTime: '',
                imageUrl: options.imageUrl,
            };
        }

        $scope.requestData = function(){
            searchByPicSend();
        };

        /**
         * [searchByPicSend 以图搜图请求]
         *
         * @return  {[type]}  [return description]
         */
        function searchByPicSend() {

            $scope.searchByPicParams.labelIds = trsspliceString.spliceString($scope.tagsData.tags, 'id', ';');
            $scope.searchByPicParams.pageNum = $scope.page.CURRPAGE;
            $scope.searchByPicParams.pageSize = $scope.page.PAGESIZE;
            $scope.searchByPicParams.customEndTime = $scope.basicalStatus.searchParams.customEndTime;
            $scope.searchByPicParams.customStartTime = $scope.basicalStatus.searchParams.customStartTime;
            clearPageData();
            $scope.loadingPromise = mrApiService.searchByPic($scope.searchByPicParams).then(function (data) {
                if (data.code === '200') {
                    $scope.items = data.datas;
                    $scope.page.ITEMCOUNT = data.summary_info.total;
                    $scope.page.PAGECOUNT = data.summary_info.pageNum;
                    $scope.isShowPicSearchResult = true;
                }
            });
        }

        /**
         * [searchBytags description] 点击确定按钮的回调函数
         * @return  {[type]}  [return description]
         */
        $scope.searchByTags = function() {
            $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = 1;
            $scope.requestData();
        };

        /**
         * [clearPageData 清除页面数据]
         *
         * @return  {[type]}  [return description]
         */
        function clearPageData() {
            $scope.items = [];
            $scope.selectedArray = [];
        }

        /**
         * [getAutoHeight description] 居中提示文字
         * @return {[type]} [description]
         */
        $scope.getAutoHeight = function () {
            $timeout(function () {
                var bodyHeight = $('.publicModal .body').height(),
                    fixedAreaHeight = $('.fixedArea').height();
                var contentHeight = bodyHeight - fixedAreaHeight;
                $('.uploadContent.localUpload').height(contentHeight);
            }, 500);
        };


        /**
         * [initData 初始化数据]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            searchByPicSend(options.imgurl);
        }

        /**
         * [loadTags description] 选择标签输入框回调函数
         * @param   {[type]}  val  [val description] 输入值
         * @return  {[type]}       [return description]
         */
        $scope.loadTags = function (val) {
            if (!val) {
                $scope.tagsData.tagsList = [];
                return;
            }
            mrApiService.getMark({ mark: val }).then(function (data) {
                $scope.tagsData.tagsList = data.datas;
            });
        };

        /**
         * [searchBytags description] 点击确定按钮的回调函数
         * @return  {[type]}  [return description]
         */
        $scope.searchByTags = function () {
            $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = 1;
            $scope.basicalStatus.searchParams.mark = trsspliceString.spliceString($scope.tagsData.tags, 'text', ',');
            searchByPicSend(options.imageUrl);
        };

        /**
         * [saveMessage 保存本地上传素材]
         *
         * @return  {[type]}  [return description]
         */
        function saveMessage() {
            returnPictureResult();
        }


        /**
         * [returnPictureResult 返回图片选择结果]
         *
         * @return  {[type]}  [return description]
         */
        function returnPictureResult() {
            $modalInstance.close({
                list: $scope.selectedArray,
            });
        }

        /**
         * [finish 完成选择]
         *
         * @return  {[type]}  [return description]
         */
        $scope.finish = function () {
            let noSelectTip = '请选择图片';
            if ($scope.selectedArray.length === 0) {
                modalDialog.alertType(noSelectTip, '', 'warning', false);
                return;
            }
            saveMessage();
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE;
            searchByPicSend(options.imageUrl);
            $('.uploadRsource .body').animate({ scrollTop: 0 }, 'fast');
        };

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function () {
            $modalInstance.dismiss();
        };


        /**
         * [loadTips description] 加载标签（智能标签）
         *
         * @param   {[type]}  word  [word description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.loadTips = function(word) {
            if (!word) {
                $scope.tagsData.tagsList = [];
                return;
            }
            var params = {
                keyword: word,
                pageNum: 1,
                pageSize: 100
            };
            $scope.loadingPromis = mediaTagApiService.getTagList(params).then(function(data){
                if (data.code === '200'){
                    $scope.tagsData.tagsList = data.datas;
                }
            });
        };
},
]);
